const getElementWithInlineStyles = (element) => {
    const baseline = document.createElement(element.tagName);
    document.body.appendChild(baseline);
    const defaultStyle = window.getComputedStyle(baseline);

    const clone = element.cloneNode(true);

    function inlineStyles(source, target) {
        const computed = window.getComputedStyle(source);
        let styleString = "";
        for (let i = 0; i < computed.length; i++) {
            const prop = computed[i];
            const value = computed.getPropertyValue(prop);
            if (value !== defaultStyle.getPropertyValue(prop)) {
                styleString += `${prop}: ${value}; `;
            }
        }
        if (styleString) target.setAttribute("style", styleString);

        for (let i = 0; i < source.children.length; i++) {
            inlineStyles(source.children[i], target.children[i]);
        }
    }

    inlineStyles(element, clone);
    document.body.removeChild(baseline);
    return clone.outerHTML;
};

export { getElementWithInlineStyles }
